<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="offset-md-3" [formGroup]="parentGroup">
  <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
    <label class="col-sm-8 control-label" for="firstName"> First Name </label>
    <div class="col-md-8">
      <input
        class="form-control"
        type="text"
        name="firstName"
        id="firstName"
        formControlName="firstName"
        [ngClass]="{
          'is-invalid':
            ownerFormControls.firstName?.invalid &&
            (ownerFormControls.firstName?.dirty ||
              ownerFormControls.firstName?.touched)
        }"
      />
      <div
        *ngIf="
          ownerFormControls.firstName?.invalid &&
          (ownerFormControls.firstName?.dirty ||
            ownerFormControls.firstName?.touched)
        "
      >
        <div
          class="text-danger"
          *ngIf="ownerFormControls.firstName?.errors?.required"
        >
          Field is required.
        </div>
      </div>
    </div>
  </div>
  <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
    <label class="col-sm-8 control-label" for="lastName"> Last Name </label>
    <div class="col-md-8">
      <input
        class="form-control"
        type="text"
        name="lastName"
        id="lastName"
        formControlName="lastName"
        [ngClass]="{
          'is-invalid':
            ownerFormControls.lastName?.invalid &&
            (ownerFormControls.lastName?.dirty ||
              ownerFormControls.lastName?.touched)
        }"
      />
      <div
        *ngIf="
          ownerFormControls.lastName?.invalid &&
          (ownerFormControls.lastName?.dirty ||
            ownerFormControls.lastName?.touched)
        "
      >
        <div
          class="text-danger"
          *ngIf="ownerFormControls.lastName?.errors?.required"
        >
          Field is required.
        </div>
      </div>
    </div>
  </div>
  <div class="form-group fieldIsRequired">
    <label class="col-sm-8 control-label" for="percentOwned">
      Percent Ownership
    </label>
    <div class="col-md-8">
      <div class="input-group">
        <input
          class="form-control"
          type="number"
          name="percentOwned"
          id="percentOwned"
          min="0"
          max="100"
          step="0.001"
          [ngClass]="{
            'is-invalid':
              ownerFormControls.percentOwned?.invalid &&
              (ownerFormControls.percentOwned?.dirty ||
                ownerFormControls.percentOwned?.touched)
          }"
          formControlName="percentOwned"
          (change)="isRequired(isMandate())"
        />
        <div class="input-group-append">
          <span class="input-group-text">%</span>
        </div>
      </div>
      <div
        *ngIf="
          ownerFormControls.percentOwned?.invalid &&
          (ownerFormControls.percentOwned?.dirty ||
            ownerFormControls.percentOwned?.touched)
        "
      >
        <div
          class="text-danger"
          *ngIf="ownerFormControls.percentOwned?.errors?.required"
        >
          Field is required.
        </div>
        <div
          class="text-danger"
          *ngIf="ownerFormControls.percentOwned?.errors?.pattern"
        >
          Maximum of 3 decimal places.
        </div>
        <div
          class="text-danger"
          *ngIf="ownerFormControls.percentOwned?.errors?.min"
        >
          Value cannot be negative.
        </div>
        <div
          class="text-danger"
          *ngIf="ownerFormControls.percentOwned?.errors?.max"
        >
          Value is too high. Max is 100.
        </div>
      </div>
    </div>
  </div>
  <div class="form-group">
    <label class="col-sm-8 control-label" for="title"> Title </label>
    <div class="col-md-8">
      <input
        class="form-control"
        type="text"
        name="title"
        id="title"
        formControlName="title"
      />
    </div>
  </div>
  <div class="form-group" [ngClass]="{ fieldIsRequired: isMandate() }">
    <label class="col-sm-8 control-label" for="ssn">
      Social Security Number
    </label>
    <div class="col-md-8">
      <input
        class="form-control"
        type="number"
        name="ssn"
        id="ssn"
        [ngClass]="{
          'is-invalid':
            ownerFormControls.ssn?.invalid &&
            (ownerFormControls.ssn?.touched || ownerFormControls.ssn?.touched)
        }"
        formControlName="ssn"
      />
      <div
        *ngIf="
          ownerFormControls.ssn?.invalid &&
          (ownerFormControls.ssn?.touched || ownerFormControls.ssn?.touched)
        "
      >
        <div
          class="text-danger"
          *ngIf="ownerFormControls.ssn?.errors?.required"
        >
          Field is required.
        </div>
        <div class="text-danger" *ngIf="ownerFormControls.ssn?.errors?.pattern">
          Social security number must be 9 digits.
        </div>
      </div>
    </div>
  </div>
  <div class="form-group" [ngClass]="{ fieldIsRequired: isMandate() }">
    <label class="col-sm-8 control-label" for="dateOfBirth">
      Date Of Birth
    </label>
    <div class="col-md-8">
      <div class="input-group">
        <input
          class="form-control"
          type="text"
          name="dateOfBirth"
          id="dateOfBirth"
          formControlName="dateOfBirth"
          matInput
          [matDatepicker]="picker"
          [ngClass]="{
            'is-invalid':
              ownerFormControls.dateOfBirth?.invalid &&
              (ownerFormControls.dateOfBirth?.dirty ||
                ownerFormControls.dateOfBirth?.touched)
          }"
          [max]="maxDate"
        />
        <div class="input-group-append">
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>
      <div
        *ngIf="
          ownerFormControls.dateOfBirth?.invalid &&
          (ownerFormControls.dateOfBirth?.dirty ||
            ownerFormControls.dateOfBirth?.touched)
        "
      >
        <div
          class="text-danger"
          *ngIf="ownerFormControls.dateOfBirth?.errors?.required"
        >
          Field is required.
        </div>
        <div
          class="text-danger"
          *ngIf="ownerFormControls.dateOfBirth?.errors?.pattern"
        >
          Invalid Date.
        </div>
      </div>
    </div>
  </div>
  <div class="form-group">
    <label class="col-sm-8 control-label" for="email"> Email </label>
    <div class="col-md-8">
      <input
        class="form-control"
        type="email"
        name="email"
        id="email"
        formControlName="email"
      />
      <div
        *ngIf="
          ownerFormControls.email?.invalid &&
          (ownerFormControls.email?.dirty || ownerFormControls.email?.touched)
        "
      >
        <div class="text-danger" *ngIf="ownerFormControls.email.errors?.email">
          Please enter a valid email address
        </div>
      </div>
    </div>
  </div>
  <div class="form-group">
    <label class="col-sm-8 control-label" for="phoneNumber">
      Phone Number
    </label>
    <div class="col-md-8">
      <input
        class="form-control"
        type="number"
        name="phoneNumber"
        id="phoneNumber"
        formControlName="phoneNumber"
        [ngClass]="{
          'is-invalid':
            ownerFormControls.phoneNumber?.invalid &&
            (ownerFormControls.phoneNumber?.dirty ||
              ownerFormControls.phoneNumber?.touched)
        }"
      />
      <div
        *ngIf="
          ownerFormControls.phoneNumber?.invalid &&
          (ownerFormControls.phoneNumber?.dirty ||
            ownerFormControls.phoneNumber?.touched)
        "
      >
        <div
          class="text-danger"
          *ngIf="ownerFormControls.phoneNumber?.errors?.pattern"
        >
          Phone number must be 10 digits.
        </div>
      </div>
    </div>
  </div>
  <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
    <label class="col-sm-8 control-label" for="addressLine1">
      Address Line 1
    </label>
    <div class="col-md-8">
      <input
        class="form-control"
        type="text"
        name="addressLine1"
        id="addressLine1"
        formControlName="addressLine1"
        [ngClass]="{
          'is-invalid':
            ownerFormControls.addressLine1?.invalid &&
            (ownerFormControls.addressLine1?.dirty ||
              ownerFormControls.addressLine1?.touched)
        }"
        maxlength="99"
      />
      <div
        *ngIf="
          ownerFormControls.addressLine1?.invalid &&
          (ownerFormControls.addressLine1?.dirty ||
            ownerFormControls.addressLine1?.touched)
        "
      >
        <div
          class="text-danger"
          *ngIf="ownerFormControls.addressLine1?.errors?.required"
        >
          Field is required.
        </div>
        <div
          class="text-danger"
          *ngIf="ownerFormControls.addressLine1?.errors?.maxlength"
        >
          Content is too long. Please shorten it.
        </div>
      </div>
    </div>
  </div>
  <div class="form-group">
    <label class="col-sm-8 control-label" for="addressLine2">
      Address Line 2
    </label>
    <div class="col-md-8">
      <input
        class="form-control"
        type="text"
        name="addressLine2"
        id="addressLine2"
        formControlName="addressLine2"
        [ngClass]="{
          'is-invalid':
            ownerFormControls.addressLine2?.invalid &&
            ownerFormControls.line?.touched
        }"
        maxlength="99"
      />
      <div
        *ngIf="
          ownerFormControls.addressLine2?.invalid &&
          ownerFormControls.addressLine2?.touched
        "
      >
        <div
          class="text-danger"
          *ngIf="ownerFormControls.addressLine2?.errors?.maxlength"
        >
          Content is too long. Please shorten it.
        </div>
      </div>
    </div>
  </div>
  <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
    <label class="col-sm-8 control-label" for="city"> City </label>
    <div class="col-md-8">
      <input
        class="form-control"
        type="text"
        name="city"
        id="city"
        formControlName="city"
        [ngClass]="{
          'is-invalid':
            ownerFormControls.city?.invalid &&
            (ownerFormControls.city?.dirty || ownerFormControls.city?.touched)
        }"
        maxlength="49"
      />
      <div
        *ngIf="
          ownerFormControls.city?.invalid &&
          (ownerFormControls.city?.dirty || ownerFormControls.city?.touched)
        "
      >
        <div
          class="text-danger"
          *ngIf="ownerFormControls.city?.errors?.required"
        >
          Field is required.
        </div>
        <div
          class="text-danger"
          *ngIf="ownerFormControls.city?.errors?.maxlength"
        >
          Content is too long. Please shorten it.
        </div>
      </div>
    </div>
  </div>
  <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
    <label class="col-sm-8 control-label" for="state"> State </label>
    <div class="col-md-8">
      <div class="row">
        <div class="col-md-8">
          <select
            class="form-control"
            name="state"
            id="state"
            formControlName="state"
            [ngClass]="{
              'is-invalid':
                ownerFormControls.state?.invalid &&
                (ownerFormControls.state?.dirty ||
                  ownerFormControls.state?.touched)
            }"
          >
            <option value="">--- Select State ---</option>
            <option *ngFor="let state of states | keyvalue" [value]="state.key">
              {{ state.value }}
            </option>
          </select>
        </div>
      </div>
      <div
        *ngIf="
          ownerFormControls.state?.invalid &&
          (ownerFormControls.state?.dirty || ownerFormControls.state?.touched)
        "
      >
        <div
          class="text-danger"
          *ngIf="ownerFormControls.state?.errors?.required"
        >
          Field is required.
        </div>
      </div>
    </div>
  </div>
  <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
    <label class="col-sm-8 control-label" for="principalzip"> Zip </label>
    <div class="col-md-8">
      <div class="row">
        <div class="col-md-4">
          <input
            class="form-control"
            type="text"
            name="principalzip"
            id="principalzip"
            formControlName="zipCode"
            [ngClass]="{
              'is-invalid':
                ownerFormControls.zipCode?.invalid &&
                (ownerFormControls.zipCode?.dirty ||
                  ownerFormControls.zipCode?.touched)
            }"
            maxlength="11"
          />
        </div>
      </div>
      <div
        *ngIf="
          ownerFormControls.zipCode?.invalid &&
          (ownerFormControls.zipCode?.dirty ||
            ownerFormControls.zipCode?.touched)
        "
      >
        <div
          class="text-danger"
          *ngIf="ownerFormControls.zipCode?.errors?.required"
        >
          Field is required.
        </div>
        <div
          class="text-danger"
          *ngIf="ownerFormControls.zipCode?.errors?.pattern"
        >
          Invalid Zip.
        </div>
      </div>
    </div>
  </div>
  <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
    <label class="col-sm-8 control-label" for="principalcountry">
      Country
    </label>
    <div class="col-md-8">
      <div class="row">
        <div class="col-md-8">
          <select
            class="form-control"
            name="principalcountry"
            id="principalcountry"
            formControlName="country"
            [ngClass]="{
              'is-invalid':
                ownerFormControls.country?.invalid &&
                (ownerFormControls.country?.dirty ||
                  ownerFormControls.country?.touched)
            }"
          >
            <option value="">--- Select Country ---</option>
            <option
              *ngFor="let country of countries | keyvalue"
              [value]="country.key"
            >
              {{ country.value }}
            </option>
          </select>
          <div
            *ngIf="
              ownerFormControls.country?.invalid &&
              (ownerFormControls.country?.dirty ||
                ownerFormControls.country?.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="ownerFormControls.country?.errors?.required"
            >
              Field is required.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="form-group"
    *ngIf="indexType === 0"
    [ngClass]="{ fieldIsRequired: isWorldPay() && indexType === 0 }"
  >
    <label class="col-sm-8 control-label" for="principaltype"> Type </label>
    <div class="col-md-8">
      <div class="row">
        <div class="col-md-8">
          <select
            class="form-control"
            name="principaltype"
            id="principaltype"
            formControlName="ownerType"
            [ngClass]="{
              'is-invalid':
                ownerFormControls.ownerType?.invalid &&
                ownerFormControls.ownerType?.touched
            }"
          >
            <option *ngIf="ownerFormControls.ownerType.value === ''" value="">
              --- Select Type ---
            </option>
            <option
              *ngIf="ownerFormControls.ownerType.value === 'Control Owner'"
            >
              Control Owner
            </option>
            <option
              *ngIf="ownerFormControls.ownerType.value !== 'Control Owner'"
            >
              {{ ownerFormControls.ownerType.value }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div>
